"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * An ActionObserver can passively listen to {@link Actor#run} inputs and outputs for all actors on a certain bus.
 *
 * ActionObserver should not edit inputs and outputs,
 * they should be considered immutable.
 *
 * @see Actor
 * @see Bus
 *
 * @template I The input type of an actor.
 * @template O The output type of an actor.
 */

var ActionObserver =
/**
 * All enumerable properties from the `args` object are inherited to this observer.
 *
 * The observer will NOT automatically subscribe to the given bus when this constructor is called.
 *
 * @param {IActionObserverArgs<I extends IAction, O extends IActorOutput>} args Arguments object
 * @throws When required arguments are missing.
 */
function ActionObserver(args) {
  _classCallCheck(this, ActionObserver);

  require('lodash.assign')(this, args);
};

exports.ActionObserver = ActionObserver;